import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable indent */
import React from 'react';
import { Grid, Box, useMediaQuery, TAGTypography, TAGLink, Container, useTheme } from '../../../';

var WNFacilityHero = function WNFacilityHero(_ref) {
  var _backgroundImage$file, _backgroundImage$file2, _backgroundImage$file3, _backgroundImage$file4, _backgroundImage$file5;

  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? true : _ref$background,
      _ref$backgroundImage = _ref.backgroundImage,
      backgroundImage = _ref$backgroundImage === void 0 ? {
    file: {
      url: ''
    }
  } : _ref$backgroundImage,
      _ref$backgroundText = _ref.backgroundText,
      backgroundText = _ref$backgroundText === void 0 ? false : _ref$backgroundText,
      location = _ref.location;
  var theme = useTheme();
  var isSmallDevice = useMediaQuery(theme.breakpoints.down(769));
  var isMediumDevice = useMediaQuery(theme.breakpoints.between(769, 1200));

  var backgroundTextStyles = function backgroundTextStyles() {
    if (!backgroundText) {
      return {
        clipPath: '',
        backgroundColor: 'transparent'
      };
    }

    return {
      clipPath: 'inset(0 0 0 0 round 0 25rem 0rem 0rem)',
      backgroundColor: '#003592'
    };
  };

  var ANGLE_BACKGROUND = _objectSpread({
    padding: '0px 0px 0px 60px',
    width: '61%',
    minHeight: '524px',
    borderRadius: '8px 0px 0px 8px'
  }, backgroundTextStyles());

  var MOBILE_BACKGROUND = {
    backgroundColor: background ? 'backgrounds.dark' : 'none'
  };
  var smallScreenImageStyles = isSmallDevice ? {} : {
    backgroundColor: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file = backgroundImage.file) !== null && _backgroundImage$file !== void 0 && _backgroundImage$file.url ? '' : 'neutrals.disabled',
    backgroundImage: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file2 = backgroundImage.file) !== null && _backgroundImage$file2 !== void 0 && _backgroundImage$file2.url ? "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : (_backgroundImage$file3 = backgroundImage.file) === null || _backgroundImage$file3 === void 0 ? void 0 : _backgroundImage$file3.url, ")") : '',
    backgroundPosition: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file4 = backgroundImage.file) !== null && _backgroundImage$file4 !== void 0 && _backgroundImage$file4.url ? '50% 50%' : '',
    backgroundSize: backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file5 = backgroundImage.file) !== null && _backgroundImage$file5 !== void 0 && _backgroundImage$file5.url ? 'cover' : ''
  };
  var smallerDevice = isSmallDevice ? {
    primaryBlock: MOBILE_BACKGROUND,
    primaryBlockPadding: '20px',
    headlineWidth: 9,
    bodyCopyWidth: 10,
    bodyCopyGridPadding: ''
  } : {
    primaryBlock: ANGLE_BACKGROUND,
    primaryBlockPadding: isMediumDevice ? '10px 0px 30px 20px' : '0px 0px 0px 60px',
    headlineWidth: 7,
    bodyCopyWidth: 7,
    bodyCopyGridPadding: isMediumDevice ? '20px 0px 30px 0px' : '20px 0px 60px 0px'
  };

  var childrenElements = function childrenElements() {
    var _backgroundImage$file6, _backgroundImage$file7, _location$details;

    return React.createElement(React.Fragment, null, isSmallDevice && (backgroundImage !== null && backgroundImage !== void 0 && (_backgroundImage$file6 = backgroundImage.file) !== null && _backgroundImage$file6 !== void 0 && _backgroundImage$file6.url ? React.createElement("img", {
      src: backgroundImage === null || backgroundImage === void 0 ? void 0 : (_backgroundImage$file7 = backgroundImage.file) === null || _backgroundImage$file7 === void 0 ? void 0 : _backgroundImage$file7.url,
      alt: "mobile image",
      width: "100%",
      style: {
        minHeight: '248px',
        maxHeight: '512px'
      }
    }) : React.createElement(Box, {
      sx: [{
        minHeight: '248px',
        maxHeight: '512px',
        backgroundColor: 'neutrals.disabled'
      }]
    })), React.createElement(Grid, {
      item: true,
      container: true,
      direction: "column",
      justifyContent: "center",
      spacing: 2,
      sx: [smallerDevice.primaryBlock, {
        padding: smallerDevice.primaryBlockPadding,
        margin: 0
      }]
    }, React.createElement(Grid, {
      item: true,
      container: true,
      sx: {
        margin: 0
      }
    }, React.createElement(Grid, {
      xs: smallerDevice.headlineWidth,
      item: true,
      display: "flex",
      justifyContent: "flex-start"
    }, React.createElement(TAGTypography, {
      variant: "h1",
      fontStyle: "heroMedium",
      color: "text.light"
    }, location.title))), React.createElement(Grid, {
      item: true,
      container: true
    }, React.createElement(Grid, {
      xs: smallerDevice.bodyCopyWidth,
      item: true,
      sx: [{
        padding: smallerDevice.bodyCopyGridPadding
      }],
      display: "flex",
      justifyContent: "flex-start"
    }, React.createElement(TAGLink, {
      variant: isSmallDevice ? 'bodyLargeBook' : 'h4',
      color: "text.light"
    }, location.address, " ", React.createElement("br", null), location.location.city, ", ", location.location.state, " ", location.location.post_code))), React.createElement(Grid, {
      item: true,
      container: true,
      spacing: 3
    }, (location === null || location === void 0 ? void 0 : (_location$details = location.details) === null || _location$details === void 0 ? void 0 : _location$details.raw) && React.createElement(Grid, {
      item: true
    }, React.createElement(Grid, {
      container: true,
      direction: "column"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.light"
    }, "Hours")), React.createElement(Grid, {
      xs: smallerDevice.bodyCopyWidth,
      item: true,
      sx: [{
        padding: smallerDevice.bodyCopyGridPadding,
        display: 'block'
      }],
      justifyContent: isSmallDevice ? 'center' : 'flex-start'
    }, JSON.parse(location.details.raw).content.map(function (content, index) {
      return React.createElement(TAGTypography, {
        key: index,
        variant: "bodyLargeBook",
        color: "text.light",
        sx: {
          display: 'block'
        }
      }, content.content[0].value);
    })))), location.phone && React.createElement(Grid, {
      item: true
    }, React.createElement(Grid, {
      container: true,
      direction: "column"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.light"
    }, "Phone")), React.createElement(Grid, {
      xs: smallerDevice.bodyCopyWidth,
      item: true,
      sx: [{
        padding: smallerDevice.bodyCopyGridPadding
      }],
      display: "flex",
      justifyContent: isSmallDevice ? 'center' : 'flex-start'
    }, React.createElement(TAGLink, {
      variant: "h4",
      color: "text.light",
      href: "tel:".concat(location.phone.replace(/[- )(]/g, ''))
    }, location.phone)))))));
  };

  return React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    sx: [_objectSpread(_objectSpread({
      borderRadius: '8px'
    }, smallScreenImageStyles), {}, _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    }))]
  }, childrenElements()));
};

export default WNFacilityHero;